import React from 'react';
import { Translation } from '~/components/Translation';
import MobileLandingSignup from '~/scenes/Signup/scenes/MobileLandingSignup';
import SignupEmailPage from '~/scenes/Signup/scenes/SignupEmailPage';
import Reviews from '~/components/Marketing/components/Header/components/Reviews/Reviews';
import { Hero } from '@sy/ssr-types';
import {
	HeroContainer,
	HeroWrap,
	LeftSection,
	SignupWrap,
	Spacer,
	Subtitle,
	Title,
	TitleHighlight,
} from './HeroSection.styled';

interface HeroSectionProps extends Hero {
	heroImage?: React.ReactNode;
	showReviews?: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({
	titleKey,
	subtitleKey,
	heroImage,
	showReviews = false,
}) => {
	return (
		<>
			<HeroContainer>
				<HeroWrap>
					<LeftSection>
						{heroImage}
						<Title variant="h1">
							{typeof titleKey === 'string' ? (
								<Translation tid={titleKey} />
							) : (
								<>
									<Translation tid={titleKey.part1} />
									<TitleHighlight>
										<Translation tid={titleKey.part2} />
									</TitleHighlight>
								</>
							)}
						</Title>
						{subtitleKey && (
							<Subtitle variant="body">
								<Translation tid={subtitleKey} />
							</Subtitle>
						)}
						{showReviews && <Reviews noPaddingTop />}
					</LeftSection>
					<Spacer />
					<SignupWrap>
						<SignupEmailPage isLandingPage isCustomLanding />
					</SignupWrap>
				</HeroWrap>
			</HeroContainer>
			<MobileLandingSignup gutterBottom />
		</>
	);
};

export default HeroSection;
